import { CollectionOrdersFilters } from './CollectionOrdersFilters';
import type { Action, FiltersState } from './localState';

type Props = {
  filters: FiltersState;
  dispatch: React.Dispatch<Action>;
  updateAccountNumber: (value: string | undefined) => Action;
  updateStatusAndReasonCode: (value: {
    status?: string;
    reasonCode?: number;
  }) => Action;
  reset: () => Action;
};

export const CollectionOrdersHeader = ({
  dispatch,
  updateAccountNumber,
  updateStatusAndReasonCode,
  reset,
  filters
}: Props) => {
  return (
    <div className="w-full items-center">
      <div className="mb-6 flex h-10 w-full flex-row justify-between">
        <div
          className="text-2xl font-medium"
          data-testid="collection-orders-header"
        >
          Orders
        </div>
      </div>
      <CollectionOrdersFilters
        filters={filters}
        updateReasonCode={updateStatusAndReasonCode}
        updateAccountNumber={updateAccountNumber}
        dispatch={dispatch}
        resetState={reset}
      />
    </div>
  );
};
